import React, { FC, MouseEventHandler } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

interface CarouselArrowProps {
    direction: "left" | "right";
    // react-multi-carousel injects onClick into custom arrows; the photo/video carousels pass their own handler.
    onClick?: MouseEventHandler<HTMLButtonElement> | (() => void);
    label?: string;
}

// The one carousel arrow used everywhere (Home carousels, lot photos, videos): round white button with a chevron.
const CarouselArrow: FC<CarouselArrowProps> = ({ direction, onClick, label }) => (
    <button
        type="button"
        className={"pb-carousel-arrow pb-carousel-arrow--" + direction}
        aria-label={label ?? (direction === "left" ? "Previous" : "Next")}
        onClick={onClick as MouseEventHandler<HTMLButtonElement>}
    >
        {direction === "left" ? <IoIosArrowBack /> : <IoIosArrowForward />}
    </button>
);

export default CarouselArrow;
